import React from 'react'
import styled from 'styled-components/macro'
import { Textbox } from '../../assets/styles/global'
import {
  responsiveMatrix,
  responsiveSlider,
  multiChoice,
  welcomePage,
  endPage,
} from '../question-types/QuestionTypes'

import { ReactComponent as Check } from '../../assets/images/HCF/check-icon.svg'
import { ReactComponent as Cross } from '../../assets/images/HCF/cross-icon.svg'
import { ReactComponent as Happy } from '../../assets/images/Scarlatti/Happy Face.svg'
import { ReactComponent as Ok } from '../../assets/images/Scarlatti/Ok face.svg'
import { ReactComponent as Sad } from '../../assets/images/Scarlatti/Sad Face.svg'
import { ReactComponent as VeryHappy } from '../../assets/images/Scarlatti/Very happy Face.svg'
import { ReactComponent as VerySad } from '../../assets/images/Scarlatti/Very sadFace 1.svg'
import { xlButton } from '../ui/Layout/ButtonContainer'
import MillsAlbert_Logo from '../../assets/images/MillsAlbert/companyLogo.png'
import backgroundVideo from '../../assets/images/Scarlatti/confer-scarlatti.mp4'

// Formatting
const IconHappy = styled(Happy)`
  width: 3rem;
  height: 3rem;
`
const IconOk = styled(Ok)`
  width: 3rem;
  height: 3rem;
`
const IconSad = styled(Sad)`
  width: 3rem;
  height: 3rem;
`
const IconVeryHappy = styled(VeryHappy)`
  width: 3rem;
  height: 3rem;
`
const IconVerySad = styled(VerySad)`
  width: 3rem;
  height: 3rem;
`

const IconCheck = styled(Check)`
  width: 45px;
  height: 80px;
`

const IconCross = styled(Cross)`
  width: 45px;
  height: 80px;
`
const StyledTextbox = styled(Textbox)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: baseline;
  width: 100%;
  li {
    font-size: 1rem;
    font-weight: 400;
  }
`
const StyledP = styled.p`
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0rem;
  margin-top: 1rem;
`

// Questions
const MillsAlbert = {
  questions: [
    // Intro Page
    {
      id: 'intro-page',
      type: welcomePage,
      buttonSize: xlButton.width,
      text: (
        <StyledTextbox style={{ alignItems: 'baseline' }}>
          <StyledP>
            Thank you for participating in this survey. The survey is completely anonymous – we will
            not be able to link answers to individuals.
          </StyledP>
          <StyledP>
            The purpose of the survey is to get an understanding of our collective wellbeing.
          </StyledP>
          <StyledP>
            We will use the results to guide us toward improving how we do things, and we will
            involve you in the process by sharing the results and asking your opinions on what we
            could do better.
          </StyledP>
        </StyledTextbox>
      ),
    },

    // ***********Delete to simplify*******************************************

    // // Question 1.1 page 1
    // {
    //   id: 'Engagement-Q1-P1',
    //   type: responsiveMatrix,
    //   section: (
    //     // <h3 style={{ color: "#e11b22" }}>Section one: Engagement</h3>
    //     <h3>Section one: Engagement</h3>
    //   ),
    //   // text: "The below questions are called the “Gallup Q12”. It is the widest used organisational engagement survey in the world. The questions (some are slightly bizarre) are based on research around what creates engagement. By answering them, we will be able to compare ourselves to other organisations, and national averages.",
    //   useIcons: true,
    //   // disclaimer: "Please rate the following statements from 1-5, where 1=strongly disagree and 5=strongly agree.",
    //   disclaimer: 'Please rate the following statements.',
    //   required: true,

    //   choices: [
    //     {
    //       id: 1,
    //       text: '1) I know what is expected of me at work:',
    //       value: 'I know what is expected of me at work',
    //     },
    //     {
    //       id: 2,
    //       text: '2) I have the materials and equipment I need to do my work right:',
    //       value: 'I have the materials and equipment I need to do my work right',
    //     },
    //     {
    //       id: 3,
    //       text: '3) At work, I have the opportunity to do what I do best every day:',
    //       value: 'At work, I have the opportunity to do what I do best every day',
    //     },
    //   ],
    //   options: [
    //     {
    //       id: 1,
    //       text: 'Strongly disagree',
    //       value: 'Strongly disagree',
    //       icon: <IconVerySad />,
    //     },
    //     {
    //       id: 2,
    //       text: 'Disagree',
    //       value: 'Disagree',
    //       icon: <IconSad />,
    //     },
    //     {
    //       id: 3,
    //       text: 'Neutral',
    //       value: 'Neutral',
    //       icon: <IconOk />,
    //     },
    //     {
    //       id: 4,
    //       text: 'Agree',
    //       value: 'Agree',
    //       icon: <IconHappy />,
    //     },
    //     {
    //       id: 5,
    //       text: 'Strongly agree',
    //       value: 'Strongly agree',
    //       icon: <IconVeryHappy />,
    //     },
    //   ],
    // },
    // // Question 1.1 page 2
    // {
    //   id: 'Engagement-Q1-P2',
    //   type: responsiveMatrix,
    //   section: (
    //     // <h3 style={{ color: "#e11b22" }}>Section one: Engagement</h3>
    //     <h3>Section one: Engagement</h3>
    //   ),
    //   useIcons: true,
    //   disclaimer: 'Please rate the following statements.',
    //   required: true,

    //   choices: [
    //     {
    //       id: 4,
    //       text:
    //         '4) In the last seven days, I have received recognition or praise for doing good work:',
    //       value:
    //         'In the last seven days, I have received recognition or praise for doing good work',
    //     },
    //     {
    //       id: 5,
    //       text: '5) My supervisor, or someone at work, seems to care about me as a person:',
    //       value: 'My supervisor, or someone at work, seems to care about me as a person',
    //     },
    //     {
    //       id: 6,
    //       text: '6) There is someone at work who encourages my development:',
    //       value: 'There is someone at work who encourages my development',
    //     },
    //   ],
    //   options: [
    //     {
    //       id: 1,
    //       text: 'Strongly disagree',
    //       value: 'Strongly disagree',
    //       icon: <IconVerySad />,
    //     },
    //     {
    //       id: 2,
    //       text: 'Disagree',
    //       value: 'Disagree',
    //       icon: <IconSad />,
    //     },
    //     {
    //       id: 3,
    //       text: 'Neutral',
    //       value: 'Neutral',
    //       icon: <IconOk />,
    //     },
    //     {
    //       id: 4,
    //       text: 'Agree',
    //       value: 'Agree',
    //       icon: <IconHappy />,
    //     },
    //     {
    //       id: 5,
    //       text: 'Strongly agree',
    //       value: 'Strongly agree',
    //       icon: <IconVeryHappy />,
    //     },
    //   ],
    // },
    // // Question 1.1 page 3
    // {
    //   id: 'Engagement-Q1-P3',
    //   type: responsiveMatrix,
    //   section: <h3>Section one: Engagement</h3>,
    //   useIcons: true,
    //   required: true,
    //   disclaimer: 'Please rate the following statements.',

    //   choices: [
    //     {
    //       id: 7,
    //       text: '7) At work, my opinions seem to count:',
    //       value: 'At work, my opinions seem to count',
    //     },
    //     {
    //       id: 8,
    //       text: '8) The mission or purpose of my company makes me feel my job is important:',
    //       value: 'The mission or purpose of my company makes me feel my job is important',
    //     },
    //     {
    //       id: 9,
    //       text: '9) My fellow employees are committed to doing quality work:',
    //       value: 'My fellow employees are committed to doing quality work',
    //     },
    //   ],
    //   options: [
    //     {
    //       id: 1,
    //       text: 'Strongly disagree',
    //       value: 'Strongly disagree',
    //       icon: <IconVerySad />,
    //     },
    //     {
    //       id: 2,
    //       text: 'Disagree',
    //       value: 'Disagree',
    //       icon: <IconSad />,
    //     },
    //     {
    //       id: 3,
    //       text: 'Neutral',
    //       value: 'Neutral',
    //       icon: <IconOk />,
    //     },
    //     {
    //       id: 4,
    //       text: 'Agree',
    //       value: 'Agree',
    //       icon: <IconHappy />,
    //     },
    //     {
    //       id: 5,
    //       text: 'Strongly agree',
    //       value: 'Strongly agree',
    //       icon: <IconVeryHappy />,
    //     },
    //   ],
    // },
    // // Question 1.1 page 4
    // {
    //   id: 'Engagement-Q1-P4',
    //   type: responsiveMatrix,
    //   section: <h3>Section one: Engagement</h3>,
    //   useIcons: true,
    //   required: true,
    //   disclaimer: 'Please rate the following statements.',

    //   choices: [
    //     {
    //       id: 10,
    //       text: '10) I have a best friend at work:',
    //       value: 'I have a best friend at work',
    //     },
    //     {
    //       id: 11,
    //       text: '11) In the last six months, someone at work has talked to me about my progress:',
    //       value: 'In the last six months, someone at work has talked to me about my progress',
    //     },
    //     {
    //       id: 12,
    //       text: '12) This last year, I have had opportunities to learn and grow:',
    //       value: 'This last year, I have had opportunities to learn and grow',
    //     },
    //   ],
    //   options: [
    //     {
    //       id: 1,
    //       text: 'Strongly disagree',
    //       value: 'Strongly disagree',
    //       icon: <IconVerySad />,
    //     },
    //     {
    //       id: 2,
    //       text: 'Disagree',
    //       value: 'Disagree',
    //       icon: <IconSad />,
    //     },
    //     {
    //       id: 3,
    //       text: 'Neutral',
    //       value: 'Neutral',
    //       icon: <IconOk />,
    //     },
    //     {
    //       id: 4,
    //       text: 'Agree',
    //       value: 'Agree',
    //       icon: <IconHappy />,
    //     },
    //     {
    //       id: 5,
    //       text: 'Strongly agree',
    //       value: 'Strongly agree',
    //       icon: <IconVeryHappy />,
    //     },
    //   ],
    // },
    // Question 1.2 (Q2.1 move here to become Q2)
    // // Question 1.3
    // {
    //   id: 'Engagement-Q3',
    //   type: commentBox,
    //   text: 'What is the part of your job you like the most?',
    //   placeholder: 'Please type here...',
    //   required: true,
    //   section: <h3>Section one: Engagement</h3>,
    // },
    // // Question 1.4
    // {
    //   id: 'Engagement-Q4',
    //   type: commentBox,
    //   text: 'If there was one thing you could change about your job, what would it be?',
    //   placeholder: 'Please type here...',
    //   required: true,
    //   section: <h3>Section one: Engagement</h3>,
    // },
    // // Section two: Welllbeing - organisation
    // // Intro Page
    // {
    //   id: 'Wellbeing-organisation-intro',
    //   type: welcomePage,
    //   section: (
    //     <StyledTextbox>
    //       {/* <h3>Section two: Wellbeing-organisation</h3>
    //                 <p style={{ marginTop: '1rem', fontSize: '1rem', lineHeight: '2' }}>All work involves stress, but not all stress is bad. In fact, without stress, we can become bored and depressed. But too much stress can cause anxiety and poor health. While it is unlikely that any organisation can remove all stressors, it is possible to minimise them.  At Mills Albert we want to do what we can to get this balance right. This section is about getting an understanding of our organisational wellbeing risks.</p>
    //                 <p style={{ marginTop: '1rem', fontSize: '1rem', lineHeight: '2' }}>When answering these questions, it can be difficult to separate work and personal life. Think carefully on each answer, reflecting on the nature of the job separate to your personal circumstances or behaviours. For example, things like having overly high standards, a tendency to procrastinate or the fact you live far away from your place of work are not caused by the job. It can be tricky to separate these things. The helpful thing to do can be to think if you were in another job – would the situation be less or more or the same?</p> */}
    //       <StyledP>Section two: Wellbeing - organisation</StyledP>
    //       <StyledP>
    //         All work involves stress, but not all stress is bad. Without stress, we can become bored
    //         and depressed. However, too much stress can cause anxiety and poor health.
    //       </StyledP>
    //       <StyledP>
    //         While it is impossible for an organisation to remove all stressors, it is possible to
    //         minimise them. At Mills Albert, we want to do what we can to get this balance right.
    //         This section is about getting an understanding of our organisational wellbeing risks.
    //       </StyledP>
    //       <StyledP>
    //         When answering these questions, it can be difficult to separate work and personal life.
    //         Think carefully on each answer, reflecting on the nature of the job separate to your
    //         personal circumstances or behaviours. For example, things like having overly high
    //         standards, a tendency to procrastinate, or the fact you live far away from your place of
    //         work are not caused by the job.
    //       </StyledP>
    //       <StyledP>
    //         It can be tricky to separate these things. The helpful thing to do can be to think if
    //         you were in another job – would the situation be more or less or the same?
    //       </StyledP>
    //     </StyledTextbox>
    //   ),
    // },

    // **************************************************************************

    {
      id: 'Q4_matrix_p1',
      type: responsiveMatrix,
      useIcons: true,
      required: true,
      // section: <h3>Section two: Wellbeing-personal</h3>,
      disclaimer: 'Please rate the following statements.',

      choices: [
        {
          id: 1,
          text: '1) Most days, I have enough energy to get through what I need',
          value: '1) Most days, I have enough energy to get through what I need',
        },
        {
          id: 2,
          text: '2) I have the time to do the things I enjoy',
          value: '2) I have the time to do the things I enjoy',
        },
        {
          id: 3,
          text: '3) I am happy with the amount and quality of sleep I get ',
          value: '3) I am happy with the amount and quality of sleep I get ',
        },
        {
          id: 4,
          text: '4) I am happy with how much exercise I get',
          value: '4) I am happy with how much exercise I get',
        },
      ],
      options: [
        {
          id: 1,
          text: 'Strongly disagree',
          value: 'Strongly disagree',
          icon: <IconVerySad />,
        },
        {
          id: 2,
          text: 'Disagree',
          value: 'Disagree',
          icon: <IconSad />,
        },
        {
          id: 3,
          text: 'Neutral',
          value: 'Neutral',
          icon: <IconOk />,
        },
        {
          id: 4,
          text: 'Agree',
          value: 'Agree',
          icon: <IconHappy />,
        },
        {
          id: 5,
          text: 'Strongly agree',
          value: 'Strongly agree',
          icon: <IconVeryHappy />,
        },
      ],
    },

    // Question 4 Part 2
    {
      id: 'Q4_matrix_p2',
      type: responsiveMatrix,
      useIcons: true,
      required: true,
      // section: <h3>Section two: Wellbeing-personal</h3>,
      disclaimer: 'Please rate the following statements.',

      choices: [
        {
          id: 5,
          text: '5) I am happy with the food choices I make',
          value: '5) I am happy with the food choices I make',
        },
        {
          id: 6,
          text: '6) I get adequate social connection',
          value: '6) I get adequate social connection',
        },
        {
          id: 7,
          text: '7) I feel financially secure',
          value: '7) I feel financially secure',
        },
      ],
      options: [
        {
          id: 1,
          text: 'Strongly disagree',
          value: 'Strongly disagree',
          icon: <IconVerySad />,
        },
        {
          id: 2,
          text: 'Disagree',
          value: 'Disagree',
          icon: <IconSad />,
        },
        {
          id: 3,
          text: 'Neutral',
          value: 'Neutral',
          icon: <IconOk />,
        },
        {
          id: 4,
          text: 'Agree',
          value: 'Agree',
          icon: <IconHappy />,
        },
        {
          id: 5,
          text: 'Strongly agree',
          value: 'Strongly agree',
          icon: <IconVeryHappy />,
        },
      ],
    },

    // Question 3 Matrix Part1
    {
      id: 'Q3_matrix_p1',
      type: responsiveMatrix,
      useIcons: true,
      required: true,
      disclaimer: 'Please rate the following statements.',
      choices: [
        {
          id: 1,
          text:
            '1) My job does NOT hinder me doing the things I love and seeing the people that are important to me',
          value:
            '1) My job does NOT hinder me doing the things I love and seeing the people that are important to me',
        },
        {
          id: 2,
          text: '2) My job does NOT negatively affect the quality of sleep I get',
          value: '2) My job does NOT negatively affect the quality of sleep I get',
        },
        {
          id: 3,
          text: '3) My job does NOT hinder me from getting the exercise that is right for me',
          value: '3) My job does NOT hinder me from getting the exercise that is right for me',
        },
      ],
      options: [
        {
          id: 1,
          text: 'Strongly disagree',
          value: 'Strongly disagree',
          icon: <IconVerySad />,
        },
        {
          id: 2,
          text: 'Disagree',
          value: 'Disagree',
          icon: <IconSad />,
        },
        {
          id: 3,
          text: 'Neutral',
          value: 'Neutral',
          icon: <IconOk />,
        },
        {
          id: 4,
          text: 'Agree',
          value: 'Agree',
          icon: <IconHappy />,
        },
        {
          id: 5,
          text: 'Strongly agree',
          value: 'Strongly agree',
          icon: <IconVeryHappy />,
        },
      ],
    },

    // Question 3 Matrix Part2
    {
      id: 'Q3_matrix_p2',
      type: responsiveMatrix,
      useIcons: true,
      required: true,
      disclaimer: 'Please rate the following statements.',
      choices: [
        {
          id: 4,
          text: '4) My job does NOT hinder me from being able to make healthy food choices',
          value: '4) My job does NOT hinder me from being able to make healthy food choices',
        },
        {
          id: 5,
          text: '5) My job does NOT make me feel isolated due to my ethnicity or gender identity ',
          value: '5) My job does NOT make me feel isolated due to my ethnicity or gender identity ',
        },
      ],
      options: [
        {
          id: 1,
          text: 'Strongly disagree',
          value: 'Strongly disagree',
          icon: <IconVerySad />,
        },
        {
          id: 2,
          text: 'Disagree',
          value: 'Disagree',
          icon: <IconSad />,
        },
        {
          id: 3,
          text: 'Neutral',
          value: 'Neutral',
          icon: <IconOk />,
        },
        {
          id: 4,
          text: 'Agree',
          value: 'Agree',
          icon: <IconHappy />,
        },
        {
          id: 5,
          text: 'Strongly agree',
          value: 'Strongly agree',
          icon: <IconVeryHappy />,
        },
      ],
    },
    // Question 1 Workload
    {
      id: 'Q1_workload',
      type: responsiveSlider,
      required: true,
      disclaimer: 'Please rate:',
      text: 'How would you rate your current workload?',
      default: 2,
      max: 10,
      marks: [
        { id: 1, text: 'Bored' },
        { id: 2, text: 'Healthy, rewarding challenges' },
        { id: 3, text: 'Burnt out' },
      ],
      choices: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    },

    // Question 2 Remuneration
    {
      id: 'Q2_remuneration',
      type: responsiveSlider,
      required: true,
      disclaimer: 'Please rate:',
      text: 'I feel remunerated fairly for the effort I put in and the contribution I make',
      default: 2,
      max: 10,
      marks: [
        { id: 1, text: 'Poor' },
        { id: 2, text: 'Neutral' },
        { id: 3, text: 'Excellent' },
      ],
      choices: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    },

    // ****************Delete for simplicity**************************************

    // Section three: Welllbeing - personal
    // Intro Page
    // {
    //   id: 'Wellbeing-personal-intro',
    //   type: welcomePage,
    //   section: (
    //     <StyledTextbox>
    //       <h3>Section two: Wellbeing-personal</h3>
    //     </StyledTextbox>
    //   ),
    // },

    // **************************************************************************

    // Question 4 Part 1

    // ****************Delete for simplicity**************************************

    // Section four: The basics
    // Intro Page
    // {
    //   id: 'Basics-intro',
    //   type: welcomePage,
    //   section: <StyledTextbox>Section three: The basics</StyledTextbox>,
    // },

    // **************************************************************************

    // Question 5 Distress
    {
      id: 'Q5_distress',
      type: multiChoice,
      required: true,
      text: 'My job creates distress',
      choices: [
        {
          id: 1,
          text: 'Yes',
          value: 'Yes',
          icon: <Check fill="currentColor" />,
          fill: '#50d250',
        },
        {
          id: 2,
          text: 'No',
          value: 'No',
          icon: <Cross fill="currentColor" />,
          fill: '#1890ff',
        },
      ],
      next: ({ answers }) => {
        if (answers['Q5_distress'].value === 'Yes') {
          return 'Q5_distress-p2'
        } else {
          return 'Q6_experience'
        }
      },
    },

    {
      id: 'Q5_distress-p2',
      type: 'imageRadioList',
      text: 'Which of the following are contributing to your work-caused distress?',
      placeholder: 'Other, please specify..',
      choices: [
        {
          id: 1,
          text: 'Lack of resources (human, equipment or budget)',
          value: 'Lack of resources (human, equipment or budget)',
          answerChoices: [
            { id: 1, value: 'Yes', icon: <IconCheck fill="currentColor" />, fill: '#50d250' },
            { id: 2, value: 'No', icon: <IconCross fill="currentColor" />, fill: '#1890ff' },
          ],
        },
        {
          id: 2,
          text: 'Lack of support',
          value: 'Lack of support',
          answerChoices: [
            { id: 1, value: 'Yes', icon: <IconCheck fill="currentColor" />, fill: '#50d250' },
            { id: 2, value: 'No', icon: <IconCross fill="currentColor" />, fill: '#1890ff' },
          ],
        },
        {
          id: 3,
          text: 'High pressure, frequent urgent deadlines',
          value: 'High pressure, frequent urgent deadlines',
          answerChoices: [
            { id: 1, value: 'Yes', icon: <IconCheck fill="currentColor" />, fill: '#50d250' },
            { id: 2, value: 'No', icon: <IconCross fill="currentColor" />, fill: '#1890ff' },
          ],
        },
        {
          id: 4,
          text: 'Frequent task switching',
          value: 'Frequent task switching',
          answerChoices: [
            { id: 1, value: 'Yes', icon: <IconCheck fill="currentColor" />, fill: '#50d250' },
            { id: 2, value: 'No', icon: <IconCross fill="currentColor" />, fill: '#1890ff' },
          ],
        },
        {
          id: 5,
          text: 'Unrealistic responsibilities',
          value: 'Unrealistic responsibilities',
          answerChoices: [
            { id: 1, value: 'Yes', icon: <IconCheck fill="currentColor" />, fill: '#50d250' },
            { id: 2, value: 'No', icon: <IconCross fill="currentColor" />, fill: '#1890ff' },
          ],
        },
        {
          id: 6,
          text: 'Human conflict / bullying / injustice ',
          value: 'Human conflict / bullying / injustice ',
          answerChoices: [
            { id: 1, value: 'Yes', icon: <IconCheck fill="currentColor" />, fill: '#50d250' },
            { id: 2, value: 'No', icon: <IconCross fill="currentColor" />, fill: '#1890ff' },
          ],
        },
        {
          id: 7,
          text: 'Other - Please specify',
          value: 'empty',
          type: 'commentBox',
        },
      ],
    },

    // Question 6 Experience
    {
      id: 'Q6_experience',
      type: multiChoice,
      required: true,
      text: 'How long have you worked at Mills Albert?',
      choices: [
        { id: 1, text: 'More than 10 years', value: 'More than 10 years' },
        { id: 2, text: 'Between 6 and 10 years', value: 'Between 6 and 10 years' },
        { id: 3, text: 'Between 3 and 5 years ', value: 'Between 3 and 5 years' },
        { id: 4, text: 'Between 1 and 3 years', value: 'Between 1 and 3 years' },
        { id: 5, text: 'Less than a year', value: 'Less than a year' },
        { id: 6, text: 'Prefer not to indicate', value: 'Prefer not to indicate' },
      ],
    },

    // Question 7 Role
    {
      id: 'Q7_role',
      type: multiChoice,
      required: true,
      // section: <h3>Section three: The basics</h3>,
      text: 'Which of the following best describes your role?',
      choices: [
        { id: 1, text: 'Civil Team Member', value: 'Civil Team Member' },
        { id: 2, text: 'Forestry Team Member', value: 'Forestry Team Member' },
        {
          id: 3,
          text: 'Workshop & Transport Team Member',
          value: 'Workshop & Transport Team Member',
        },
        { id: 4, text: 'Office Based Worker', value: 'Office Based Worker' },
        { id: 5, text: 'Superintendent/Supervisor', value: 'Superintendent/Supervisor' },
      ],
    },
    // {
    //   id: 'Basics-Q2',
    //   type: multiChoice,
    //   required: true,
    //   // section: <h3>Section four: The basics</h3>,
    //   text: 'Which of the following best describes your role?',
    //   choices: [
    //     { id: 1, text: 'Civil Team Member', value: 'Civil Team Member' },
    //     { id: 2, text: 'Forestry Team Member', value: 'Forestry Team Member' },
    //     {
    //       id: 3,
    //       text: 'Workshop & Transport Team Member',
    //       value: 'Workshop & Transport Team Member',
    //     },
    //     { id: 4, text: 'Office Based Worker', value: 'Office Based Worker' },
    //     { id: 5, text: 'Superintendent/Supervisor', value: 'Superintendent/Supervisor' },
    //   ],
    // },

    // End page
    {
      id: 'End-page',
      type: endPage,
      text: 'Thank you for participating – we will share the results with you soon😊',
    },
  ],
  settings: {
    surveyName: 'mills_albert',
    primaryColour: '#43583c',
    progressBar: true,
    useVideo: true,
    objectPosition: 'center',
    backgroundVideo,
    // showQid: true,
    hideSubmit: true,

    // logo
    companyLogo: {
      images: [{ image: MillsAlbert_Logo }],
    },
    logoFirstPageOnly: true,
    logoLocation: 'space-between',
    logoStyle: {
      marginTop: '1rem',
    },
  },
}

export default MillsAlbert
